var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view cost-tasks"},[_c('app-sub-navbar',{attrs:{"parent":"cost"}}),_vm._v(" Tasks ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }